import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { v_DispatchStatusHistoryBus } from '../../../shared/models/v_DispatchStatusHistoryBus';
import { BaseGridUIComponent } from '../../../shared/base-components/base-grid-ui.component';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';

@Component({
    selector: 'dispatch-status-history',
    templateUrl: './dispatch-status-history.component.html',
    styleUrls: ['./dispatch-status-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchStatusHistoryComponent extends BaseGridUIComponent<v_DispatchStatusHistoryBus, null, DispatchesService>  {

    dispatchStatusFC: MSFilterClass = new MSFilterClass('dispatchStatusName');
  constructor(globals: GlobalsService, svc_data: DispatchesService) {
    super(globals);
    this.svc_data = svc_data;
  }
}
